define("shared/components/shared/ui/social-set-switcher", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _switchableSets;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if @readonly}}
    <div
      class="o--btn o--btn--outline o--btnDrop o--page__switcher tPA--switcher qa--profile_switcher is--readonly"
      ...attributes
    >
      {{#if @tooltip}}
        <EmberTooltip @delay={{330}} @side="top">
          {{@tooltip}}
        </EmberTooltip>
      {{/if}}
      <Shared::Ui::SocialSetSwitcher::SocialSet
        @disableHover={{true}}
        @hideTwitterIdentities={{@hideTwitterIdentities}}
        @index={{rebase-indexed-number this.selectedSocialSetIndex}}
        @isFocused={{true}}
        @isMobile={{user-agent "device.isMobile"}}
        @shouldHaveLabel={{false}}
        @showAllProfilesOnMobile={{@showAllProfilesOnMobile}}
        @socialIdentity={{this.selectedSocialSet}}
      />
    </div>
  {{else}}
    <BasicDropdown ...attributes as |emberDrop|>
      <emberDrop.Trigger @htmlTag="span">
        <div
          class="o--btn o--btn--outline o--btnDrop o--page__switcher tPA--switcher qa--profile_switcher"
          {{did-insert this.addMobileClass}}
        >
          <Shared::Ui::SocialSetSwitcher::SocialSet
            @disableHover={{true}}
            @hideTwitterIdentities={{@hideTwitterIdentities}}
            @index={{rebase-indexed-number this.selectedSocialSetIndex}}
            @isFocused={{true}}
            @isMobile={{user-agent "device.isMobile"}}
            @shouldHaveLabel={{false}}
            @showAllProfilesOnMobile={{@showAllProfilesOnMobile}}
            @socialIdentity={{this.selectedSocialSet}}
          >
            {{svg-jar "caret-down" class="o--icon o--btnDrop__icon"}}
          </Shared::Ui::SocialSetSwitcher::SocialSet>
        </div>
      </emberDrop.Trigger>
      <emberDrop.Content>
        <Shared::Ui::SocialSetSwitcher::List
          @hideTwitterIdentities={{@hideTwitterIdentities}}
          @isMobile={{user-agent "device.isMobile"}}
          @selectSocialSet={{this.selectSocialSet}}
          @selectedSocialSet={{this.selectedSocialSet}}
          @showAllProfilesOnMobile={{@showAllProfilesOnMobile}}
          @switchableSets={{@switchableSets}}
          @unswitchableSets={{@unswitchableSets}}
          {{on "click" emberDrop.actions.close}}
        />
      </emberDrop.Content>
    </BasicDropdown>
  {{/if}}
  */
  {
    "id": "M92b7vky",
    "block": "[[[41,[30,1],[[[1,\"  \"],[11,0],[24,0,\"o--btn o--btn--outline o--btnDrop o--page__switcher tPA--switcher qa--profile_switcher is--readonly\"],[17,2],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[8,[39,1],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[8,[39,2],null,[[\"@disableHover\",\"@hideTwitterIdentities\",\"@index\",\"@isFocused\",\"@isMobile\",\"@shouldHaveLabel\",\"@showAllProfilesOnMobile\",\"@socialIdentity\"],[true,[30,4],[28,[37,3],[[30,0,[\"selectedSocialSetIndex\"]]],null],true,[28,[37,4],[\"device.isMobile\"],null],false,[30,5],[30,0,[\"selectedSocialSet\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,5],[[17,2]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,6,[\"Trigger\"]],null,[[\"@htmlTag\"],[\"span\"]],[[\"default\"],[[[[1,\"\\n      \"],[11,0],[24,0,\"o--btn o--btn--outline o--btnDrop o--page__switcher tPA--switcher qa--profile_switcher\"],[4,[38,6],[[30,0,[\"addMobileClass\"]]],null],[12],[1,\"\\n        \"],[8,[39,2],null,[[\"@disableHover\",\"@hideTwitterIdentities\",\"@index\",\"@isFocused\",\"@isMobile\",\"@shouldHaveLabel\",\"@showAllProfilesOnMobile\",\"@socialIdentity\"],[true,[30,4],[28,[37,3],[[30,0,[\"selectedSocialSetIndex\"]]],null],true,[28,[37,4],[\"device.isMobile\"],null],false,[30,5],[30,0,[\"selectedSocialSet\"]]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,7],[\"caret-down\"],[[\"class\"],[\"o--icon o--btnDrop__icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,6,[\"Content\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,8],[[4,[38,9],[\"click\",[30,6,[\"actions\",\"close\"]]],null]],[[\"@hideTwitterIdentities\",\"@isMobile\",\"@selectSocialSet\",\"@selectedSocialSet\",\"@showAllProfilesOnMobile\",\"@switchableSets\",\"@unswitchableSets\"],[[30,4],[28,[37,4],[\"device.isMobile\"],null],[30,0,[\"selectSocialSet\"]],[30,0,[\"selectedSocialSet\"]],[30,5],[30,7],[30,8]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[6]]]]],[1,\"\\n\"]],[]]]],[\"@readonly\",\"&attrs\",\"@tooltip\",\"@hideTwitterIdentities\",\"@showAllProfilesOnMobile\",\"emberDrop\",\"@switchableSets\",\"@unswitchableSets\"],false,[\"if\",\"ember-tooltip\",\"shared/ui/social-set-switcher/social-set\",\"rebase-indexed-number\",\"user-agent\",\"basic-dropdown\",\"did-insert\",\"svg-jar\",\"shared/ui/social-set-switcher/list\",\"on\"]]",
    "moduleName": "shared/components/shared/ui/social-set-switcher.hbs",
    "isStrictMode": false
  });
  let SocialSetSwitcherComponent = _exports.default = (_class = (_switchableSets = /*#__PURE__*/new WeakMap(), class SocialSetSwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateFieldInitSpec(this, _switchableSets, {
        get: _get_switchableSets,
        set: void 0
      });
      _initializerDefineProperty(this, "userAgent", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialSet", _descriptor2, this);
    }
    get isMobile() {
      return this.userAgent.device.isMobile;
    }
    get selectedSocialSetIndex() {
      for (const identity of _classPrivateFieldGet(this, _switchableSets)) {
        if (this.selectedSocialSet === identity.socialIdentity) {
          return identity.index;
        }
      }
      return _classPrivateFieldGet(this, _switchableSets)[0]?.index;
    }
    selectSocialSet(socialIdentity) {
      if (typeof this.args.onChange === 'function') {
        this.args.onChange(socialIdentity);
      }
      this.selectedSocialSet = socialIdentity;
    }
    addMobileClass() {
      if (this.isMobile) {
        const element = document.getElementById('ember-basic-dropdown-wormhole');
        element?.classList.add('u--mobile');
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialSet", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.selectedSet || this.args.switchableSets[0]?.socialIdentity;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "selectSocialSet", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSocialSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addMobileClass", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addMobileClass"), _class.prototype)), _class);
  function _get_switchableSets() {
    return this.args.switchableSets;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialSetSwitcherComponent);
});